<div class="hexagon-icon hexagon-icon--step-{{step}}">
  <img *ngIf="!questMode" [src]="'assets/img/hexagons/purple.svg'" [alt]="'Hexagon'">
  <img *ngIf="questMode" [src]="'assets/img/hexagons/green.svg'" [alt]="'Hexagon'">
</div>


